import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

// Landing page for the Google OAuth redirect: SessionsController sends the JWT
// here as ?token=... We store it and bounce to the app.
export default function AuthCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { login } = useAuth()

  useEffect(() => {
    const token = params.get('token')
    const run = async () => {
      if (token) {
        await login(token)
        navigate('/', { replace: true })
      } else {
        navigate('/login?error=' + (params.get('error') ?? 'auth_failed'), { replace: true })
      }
    }
    run()
  }, [params, login, navigate])

  return <div className="min-h-screen grid place-items-center text-slate-500">Signing you in…</div>
}
